import Tether from 'tether';

angular.module('vrm.components').directive('vrmTooltip', vrmTooltip);

/* @ngInject */
function vrmTooltip($compile) {

    return {
        restrict: 'A',
        scope: {
            tooltipContent: '@vrmTooltip',
            tooltipTrigger: '=vrmTooltipTrigger',
            tooltipOffset: '=vrmTooltipOffset',
        },
        link,
    };

    function link($scope, $element, $attr) {
        $scope.tether = null;
        $scope.shown = false;
        const isBefore = $element.hasClass('vrm-tooltip--bottom') || $element.hasClass('vrm-tooltip--right');
        const enabledMobile = $element.hasClass('vrm-tooltip--mobile');

        const touchDevice = ('ontouchstart' in document.documentElement);

        const generatedTooltip = $compile(
            `<div class="vrm-tooltip ${(enabledMobile ? 'vrm-tooltip--mobile' : '')}" ng-class="{'vrm-tooltip--empty': !tooltipContent.length}">` +
                (!isBefore ? '<div class="vrm-tooltip__content" data-i18n="{{tooltipContent}}"></div>' : '') +
                '<div class="vrm-tooltip__arrow">' +
                    '<div class="vrm-tooltip__arrow-inner"></div>' +
                '</div>' +
                (isBefore ? '<div class="vrm-tooltip__content" data-i18n="{{tooltipContent}}"></div>' : '') +
            '</div>')($scope);
        const vrmTooltipRemoveClassName = 'vrm-remove';

        const classesToCheck = [
            'vrm-tooltip--arrow-left',
            'vrm-tooltip--arrow-right',
            'vrm-tooltip--bottom',
            'vrm-tooltip--light',
            'vrm-tooltip--left'
        ];
        const extraClassesPrefix = 'vrm-tooltip--extra';

        function _clearTether() {
            if ($scope.tether != null) {
                $scope.tether.destroy();
            }
        }

        classesToCheck.forEach((curClass) => {
            if ($element.hasClass(curClass))
                generatedTooltip.addClass(curClass);
            else
                generatedTooltip.removeClass(curClass);
            // Add all classes that starts with the prefix
            Array.from($element[0].classList)
                .filter(item => item.startsWith(extraClassesPrefix))
                .forEach(item => generatedTooltip.addClass(item));
        });

        function showTooltip() {
            $element.after(generatedTooltip);
            generatedTooltip.removeClass(vrmTooltipRemoveClassName);

            let attachment = 'bottom center';
            let targetAttachment = 'top center';
            const targetOffset = $attr.tooltipOffset || '-15px 0';
            if ($element.hasClass('vrm-tooltip--bottom')) {
                attachment = 'top center';
                targetAttachment = 'bottom center';
            }
             else if ($element.hasClass('vrm-tooltip--right')) {
                attachment = 'middle left';
                targetAttachment = 'middle right';
            }
            else if ($element.hasClass('vrm-tooltip--left')) {
                attachment = 'top left';
                targetAttachment = 'middle right';
            }

            _clearTether();
            $scope.tether = new Tether({
                element: generatedTooltip,
                target: $element,
                attachment: attachment,
                targetAttachment: targetAttachment,
                targetOffset: targetOffset,
                constraints: [{
                    to: 'window',
                    pin: ['left', 'right']
                }]
            });
            $scope.shown = true;
            // Resize event is needed to recalculate the position of the tooltip
            // Tried using $scope.watch on 'shown' but it triggers too late
            [0, 10, 30, 200, 400, 1000].forEach((delay) => {
                setTimeout(() => {
                    window.dispatchEvent(new Event('resize'));
                }, delay);
            });
        }

        function hideTooltip() {
            $scope.shown = false;
            generatedTooltip.addClass(vrmTooltipRemoveClassName);
            _clearTether();
        }

        document.addEventListener("click", (event)=>{
            if (!touchDevice || !enabledMobile) return;
            if ($scope.shown && event.target != $element[0]) hideTooltip();
        });


        if ($attr.vrmTooltipTrigger) {
            // Setup programmatic trigger
            $scope.$watch('tooltipTrigger', (value) => {
                if (value) {
                    showTooltip();
                } else {
                    hideTooltip();
                }
            });
        } else {
            // Setup mouseover trigger
            $element.on('click', () => {
                // Delay is needed to prevent the tooltip from being hidden immediately after being shown due to the click event on document
                setTimeout(() => {
                    if (!touchDevice || !enabledMobile) return;
                    if ($scope.shown) {
                        hideTooltip();
                    } else {
                        showTooltip();
                    }
                }, 50);
            });

            $element.on('mouseover', () => {
                if (!touchDevice)
                    showTooltip();
            });

            $element.on('mouseout', () => {
                if (!touchDevice)
                    hideTooltip();
            });
        }

        $scope.$on('$destroy', () => {
            $element.off();
            _clearTether();
            generatedTooltip.remove();
        });
    }
}
